// extracted by mini-css-extract-plugin
module.exports =  {"cont":"_0bc5e8de02--cont--NCtU6","controls":"_0bc5e8de02--controls--IjJzU","gallery-arrow":"_0bc5e8de02--gallery-arrow--DtLob"};